import React from "react";
import { ColumnsLayout } from "@components";
import { Impressum } from "./Impressum";

export const ImpressumPage = () => {
  return (
    <ColumnsLayout>
      <Impressum />
    </ColumnsLayout>
  );
};
